//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: 'ä»¤å',
                narrow: 'ã¿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: 'å¹³æ',
                narrow: 'ã»',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: 'æ­å',
                narrow: 'ã¼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: 'å¤§æ­£',
                narrow: 'ã½',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: 'ææ²»',
                narrow: 'ã¾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: 'è¥¿æ¦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'ç´åå',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(å|\d+)å¹´/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === 'å' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1æ_2æ_3æ_4æ_5æ_6æ_7æ_8æ_9æ_10æ_11æ_12æ'.split('_'),
        monthsShort: '1æ_2æ_3æ_4æ_5æ_6æ_7æ_8æ_9æ_10æ_11æ_12æ'.split(
            '_'
        ),
        weekdays: 'æ¥ææ¥_æææ¥_ç«ææ¥_æ°´ææ¥_æ¨ææ¥_éææ¥_åææ¥'.split('_'),
        weekdaysShort: 'æ¥_æ_ç«_æ°´_æ¨_é_å'.split('_'),
        weekdaysMin: 'æ¥_æ_ç«_æ°´_æ¨_é_å'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYYå¹´MæDæ¥',
            LLL: 'YYYYå¹´MæDæ¥ HH:mm',
            LLLL: 'YYYYå¹´MæDæ¥ dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYYå¹´MæDæ¥',
            lll: 'YYYYå¹´MæDæ¥ HH:mm',
            llll: 'YYYYå¹´MæDæ¥(ddd) HH:mm',
        },
        meridiemParse: /åå|åå¾/i,
        isPM: function (input) {
            return input === 'åå¾';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'åå';
            } else {
                return 'åå¾';
            }
        },
        calendar: {
            sameDay: '[ä»æ¥] LT',
            nextDay: '[ææ¥] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[æ¥é±]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[æ¨æ¥] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[åé±]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}æ¥/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? 'åå¹´' : number + 'å¹´';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + 'æ¥';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%så¾',
            past: '%så',
            s: 'æ°ç§',
            ss: '%dç§',
            m: '1å',
            mm: '%då',
            h: '1æé',
            hh: '%dæé',
            d: '1æ¥',
            dd: '%dæ¥',
            M: '1ã¶æ',
            MM: '%dã¶æ',
            y: '1å¹´',
            yy: '%då¹´',
        },
    });

    return ja;

})));
